import { getOrderItemsByRewardIds } from './get-order-items-by-reward-ids';
export const getOrderItemCountByRewardIds = (rewardIds) => {
    return getOrderItemsByRewardIds(rewardIds).length;
};
